<template>
    <div class="viewBox">
       <div class="editor">
           <div class="left">
               <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                    <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/faceDetect/${item}`" >
               </button>
            </div>
            <div class="center">
                <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/faceDetect/${photoList[photoActiveIndex]}`" alt="">
                <div class="rect" :style="item.style" v-for="(item,index) in nate[photoActiveIndex].rectList" :key="index"></div>
            </div>
            <div class="right">
                <div class="header">
                    <span>人脸识别</span>
                    <span>可能性</span>
                </div>
                <div class="content" v-if=" detect[photoActiveIndex]">
                    <div class="item"  v-for="(item,index) in detect[photoActiveIndex].faceDetect" :key="index">
                        <img :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/faceDetect/${item.img}`" alt="">
                        <p>性别<span>{{item.gender}}</span></p>
                        <p>年龄<span>{{item.age}}</span></p>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
import Axios from "axios";
export default {
    data(){
        return{
            photoList:[
                '1.jpg',
                '2.jpg',
                '3.jpg',
                '4.jpg',
            ],
            photoActiveIndex:0,
            detect:[],
            nate:[
                {
                    rectList:[
                        {
                            style:{
                                inset: '23.26% 52.5% 41.46% 28.75%'
                            }
                        },
                        {
                            style:{
                                inset: '25.89% 33.87% 39.4% 47.88%'
                            }
                        }
                    ]
                },
                {
                    rectList:[
                        {
                            style:{
                                inset: '23.26% 29.13% 32.46% 44.12%'
                            }
                        },
                       
                    ]
                },
                {
                    rectList:[
                        {
                            style:{
                                inset: '36.77% 56.13% 47.28% 35.38%'
                            }
                        },
                        {
                            style:{
                                inset: '28.52% 40.5% 54.41% 51%'
                            }
                        }
                    ]
                },
                {
                    rectList:[
                        {
                            style:{
                                inset: '25.7% 45% 30.21% 28.25%'
                            }
                        },
                        {
                            style:{
                                inset: '35.65% 22.63% 21.39% 51.5%'
                            }
                        }
                    ]
                }
            ]
        }
    },

    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
        },
    },
    created() {
       Axios.get('json/faceDetect.json').then((res)=>{
            this.detect = res.data;
       })
    },
}
</script>
<style lang="scss" scoped>
      .editor{
        width:100%;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
            width: 244px;
            position: relative;
            padding: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            button{
                width: 102px;
                height: 102px;
                border: none;
                padding: 0;
                overflow: hidden;
                position: relative;
                margin-top: 18px;
                &:first-child{
                    margin-top: 0;
                }
                cursor: pointer;
                img{
                    width: inherit;
                    height: inherit;
                    position: absolute;
                    top: 0;
                    left: 0;
                    -o-object-fit: cover;
                    object-fit: cover;
                    -o-object-position: center;
                    object-position: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
            }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
        }
        .center{
            -ms-flex: 1 1;
            flex: 1 1;
            padding: 50px;
            background-color: #202537;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: row;
            flex-direction: row;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            img{
                position: relative;
                width: 100%;
                z-index: 1;
                min-height: 100px;
                overflow: hidden;
            }
            .rect{
                position: absolute;
                border: 4px solid #5986ff;
                z-index: 2;
            }
        }
        .right{
            width: 244px;
            position: relative;
            .header{
                padding: 24px;
                color: #a0a3af;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                border-bottom: 1px solid rgba(81,86,102,0.5);
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: justify;
                justify-content: space-between;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }
            .content{
                position: relative;
                z-index: 1;
                padding: 4px 0;
                max-height: 608px;
                min-height: 458px;
                overflow-y: auto;
                width: auto;
                     margin: 0;
                .item{
                    position: relative;
                    padding: 12px 24px;
                    -webkit-transition: background-color ease-in-out 280ms;
                    -o-transition: background-color ease-in-out 280ms;
                    transition: background-color ease-in-out 280ms;
                    &:hover{
                        background-color: #202537;
                    }
                    img{
                        width: 60px;
                        height: 60px;
                        -o-object-position: center;
                        object-position: center;
                        -o-object-fit: cover;
                        object-fit: cover;
                        display: block;
                        margin-bottom: 16px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }
                    p{
                        font-size: 14px;
                        line-height: 25px;
                        color: #a0a3af;
                        margin: 0;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        span{
                           color: #fff;
                             float: right; 
                        }
                    }
                }
            }
        }
    }
</style>